/* Translates the configurator labels that are built in JavaScript. Dictionary comes from window.PCI18N. */
(function () {
  function translate(root) {
    var D = window.PCI18N;
    if (!D) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) {
      var raw = n.nodeValue, t = raw.trim();
      if (!t) continue;
      if (D[t]) { n.nodeValue = raw.replace(t, D[t]); continue; }
      var m = t.match(/^Min ([0-9.]+) m, max ([0-9.]+) m$/);
      if (m && D.minmax) n.nodeValue = raw.replace(t, D.minmax.replace('{a}', m[1]).replace('{b}', m[2]));
    }
    root.querySelectorAll('[title]').forEach(function (e) {
      if (D[e.getAttribute('title')]) e.setAttribute('title', D[e.getAttribute('title')]);
    });
  }
  function init() {
    document.querySelectorAll('[data-pc]').forEach(function (sec) {
      var panel = sec.querySelector('[data-panel]');
      if (!panel || panel.dataset.pchI18n) return;
      panel.dataset.pchI18n = '1';
      translate(panel);
      new MutationObserver(function () { translate(panel); }).observe(panel, { childList: true, subtree: true });
      sec.querySelectorAll('form').forEach(function (f) {
        f.addEventListener('submit', function () {
          var b = f.querySelector('[data-body]');
          if (b && window.PCLANG && b.value.indexOf('Language:') < 0) b.value += '\nLanguage: ' + window.PCLANG;
        });
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();